import { Badge, Button, Checkbox, DatePicker, message, Select, Tooltip, FloatButton } from "antd";
import { useEffect, useState, useMemo, useRef } from "react";
import { serverFetch } from "../../server";
import "./records.css";
import { isMobile } from '../../extensions/design';
import RecordsHeader from "./records-header";
import RecordsLine from "./records-line";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import "dayjs/locale/ru";
import { cnvString2Time, strDate2Server } from "../../extensions/utils";
import Record from "./record";
import RecordsItem from "./records-item";
import RecordVisit from "./record-visit";
import RecordsCopy from "./records-copy";
import RecordsRezItems from "./records-rez-items";
import RecordsSmart from "./records-smart";
import { HelpButton, RefreshButton, CopyButton, SmartButton } from "../../extensions/design";
import RecordSmartVisit from "./record-smart-visit";
import ButtonReport from "../../controls/button-report/button-report";
import { dictsGetCalendars } from "../../extensions/dicts";
import { PlusOutlined, PlusSquareOutlined, AppstoreAddOutlined, ScheduleOutlined, LeftOutlined, RightOutlined, CloseCircleOutlined } from "@ant-design/icons";
import recordSignalRService from "../../services/recordSignalRService";
import { useSelector } from "react-redux";
import RecordsWeek from "./records-week";
import RecordsMonth from "./records-month";
import { applyTimeToDate, getPeriodRange, PERIOD_OPTIONS } from "./records-status";

dayjs.extend(isoWeek);
dayjs.locale("ru");

const vidOptions = [
  { value: 0, label: "Сотрудники" },
  { value: 1, label: "Залы" },
]

const filtersTypes = [
  { value: 0, label: "Сотрудники" },
  { value: 1, label: "Залы" },
  { value: 2, label: "По клиентам"}
]
const minColWidth = 36;

/** Записи */
const Records = () => {
  const [company, setCompany] = useState();
  const [users, setUsers] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [date, setDate] = useState(dayjs());
  const [period, setPeriod] = useState(() => {
    const saved = localStorage.getItem("records-period");
    return saved === "week" || saved === "month" ? saved : "day";
  });
  const [grafs, setGrafs] = useState([]); // Слоты работы сотрудников
  const [calendars, setCalendars] = useState([]); // ID календарей, для которых выбранная дата рабочая (для фильтрации сотрудников)
  const [calendarsList, setCalendarsList] = useState([]); // Список календарей с названиями для отображения в хинте
  const [selectedTime, setSelectedTime] = useState(); // Выбранное время для добавления новой записи
  const [selectedItem, setSelectedItem] = useState(); // Выбранная запись
  const [records, setRecords] = useState([]);
  const [visitItem, setVisitItem] = useState();
  const [showDeleted, setShowDeleted] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showCopy, setShowCopy] = useState(false);
  const [rezItems, setRezItems] = useState([]);
  const [rezShow, setRezShow] = useState(false);
  const [clients, setClients] = useState([]);
  // Для аккордеона
  const [isExpanded, setIsExpanded] = useState(false);

  const user = useSelector((s) => s.user);
  const [vid, setVid] = useState(() => {
    // Загружаем сохраненный режим из localStorage
    const saved = localStorage.getItem('records-vid');
    return saved ? parseInt(saved) : 0;
  });
  const [smartRecord, setSmartRecord] = useState(false);
  const [userColWidth, setUserColWidth] = useState(() => {
    // Загружаем сохраненную ширину из localStorage
    const saved = localStorage.getItem('records-userColWidth');
    return saved ? parseInt(saved) : 200;
  });
  const [hourRowHeight, setHourRowHeight] = useState(() => {
    // Загружаем сохраненную высоту из localStorage
    const saved = localStorage.getItem('records-hourRowHeight');
    return saved ? parseInt(saved) : 50;
  });
  const [isResizing, setIsResizing] = useState(false);
  const [isResizingHeight, setIsResizingHeight] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [selectedClient, setSelectedClient] = useState();
  const [signalRConnected, setSignalRConnected] = useState(false);
  const previousDateRef = useRef(null);

  //Тип фильтра для мобильного (подгрузка из памяти, если такое есть)
  const [mobileTypeFilter, setMobileTypeFilter] = useState(() => {
    const saved = localStorage.getItem('mobileTypeFilter');
    return saved !== null ? Number(saved) : 0;
  });

  // Списки уникальных залов и сотрудников
  const [uniqueValues, setUniqueValues] = useState([]);
  const [currentFilter, setCurrentFilter] = useState([]);

  // Триггеры типа записи:
  // 1 - запись, 2 - смарт-запись
  const [mode, setMode] = useState();

  const getRecords = () => {
    const { begin, end } = getPeriodRange(date, period);
    const mapRecord = (item) => ({
      ...item,
      start: applyTimeToDate(item.start, item.docDate),
      finish: applyTimeToDate(item.finish, item.docDate),
    });

    serverFetch(`record?dateBegin=${strDate2Server(begin)}&dateEnd=${strDate2Server(end)}`)
      .then(data => {
        const mapped = data.map(mapRecord);
        setRecords(mapped);
        setVisitItem(prev => (prev ? mapped.find(r => r.id === prev.id) ?? prev : prev));
        const newClients = [];
        data.forEach(record => {
          (record.cnts || []).filter(i => i.objectVid === 1).forEach(cnt => {
            if (!newClients.find(i => i.value === cnt.objectId))
              newClients.push({value: cnt.objectId, label: cnt.objectName});
          })
        });
        setClients(newClients.sort((a, b) => a.label?.localeCompare(b.label) ?? 0));
        setCurrentFilter(null);
        setUniqueValues(null);
      })
      .catch(e => message.error(e.userMessage));
    serverFetch("record")
      .then(data => setRezItems(data))
      .catch(e => message.error(e.userMessage));
  }

  useEffect(() => {
    serverFetch("company/current")
      .then(data => setCompany(data))
      .catch(e => message.error(e.userMessage));
    serverFetch("user")
      .then(data => setUsers(data))
      .catch(e => message.useMessage);
    serverFetch("room")
      .then(data => setRooms(data))
      .catch(e => message.error(e.userMessage));
    dictsGetCalendars(setCalendarsList);
  }, [])

  const getGrafs = () => {
    serverFetch(`user/schedule?dateStart=${strDate2Server(date)}&dateFinish=${strDate2Server(date)}`)
      .then(data => {
        // Добавляем время начала и окончания в минутах
        setGrafs(data.map(i => ({...i, 
          startMin: cnvString2Time(i.start).diff(cnvString2Time(i.start).startOf('day'), 'minute'),
          finishMin: cnvString2Time(i.finish).diff(cnvString2Time(i.finish).startOf('day'), 'minute'),
        })));
        setCalendars([...new Set(data.map(i => i.calendarId))]);
      })
      .catch(e => e.userMessage);
  }

  useEffect(getGrafs, [date, vid]);

  useEffect(getRecords, [date, period]);

  // Инициализация SignalR подключения
  useEffect(() => {
    const sessionId = user?.sessionId;
    // console.log(sessionId, user);
    if (!sessionId) {
      console.warn("SessionId не найден, SignalR не будет инициализирован");
      return;
    }

    // Обработчики событий SignalR
    const handleRecordAdded = (event) => {
      if (!event.record) return;
      
      const newRecord = {
        ...event.record,
        start: applyTimeToDate(event.record.start, event.record.docDate),
        finish: applyTimeToDate(event.record.finish, event.record.docDate)
      };
      
      setRecords(prevRecords => {
        // Проверяем, нет ли уже такой записи
        const exists = prevRecords.find(r => r.id === newRecord.id);
        if (exists) return prevRecords;
        
        return [...prevRecords, newRecord];
      });

      // Обновляем список клиентов если нужно
      const newClients = event.record.cnts?.filter(i => i.objectVid === 1) || [];
      if (newClients.length > 0) {
        setClients(prevClients => {
          const updatedClients = [...prevClients];
          newClients.forEach(cnt => {
            if (!updatedClients.find(i => i.value === cnt.objectId)) {
              updatedClients.push({value: cnt.objectId, label: cnt.objectName});
            }
          });
          return updatedClients.sort((a, b) => a.label?.localeCompare(b.label) ?? 0);
        });
      }

      // message.success(`Добавлена новая запись: ${event.record.comment || 'без комментария'}`);
    };

    const handleRecordUpdated = (event) => {
      if (!event.record) return;
      
      const updatedRecord = {
        ...event.record,
        start: applyTimeToDate(event.record.start, event.record.docDate),
        finish: applyTimeToDate(event.record.finish, event.record.docDate)
      };
      
      setRecords(prevRecords => {
        return prevRecords.map(r => 
          r.id === updatedRecord.id ? updatedRecord : r
        );
      });

      // message.info(`Запись обновлена: ${event.record.comment || `ID ${event.recordId}`}`);
    };

    const handleRecordsUpdated = (events) => {
      if (!Array.isArray(events)) return;
      
      events.forEach(event => {
        if (!event.record) return;
        
        const updatedRecord = {
          ...event.record,
          start: applyTimeToDate(event.record.start, event.record.docDate),
          finish: applyTimeToDate(event.record.finish, event.record.docDate)
        };
        
        setRecords(prevRecords => {
          return prevRecords.map(r =>
            r.id === updatedRecord.id ? updatedRecord : r
          );
        });
      });
    };

    const handleRecordDeleted = (event) => {
      setRecords(prevRecords => {
        return prevRecords.filter(r => r.id !== event.recordId);
      });

      // message.warning(`Запись удалена: ID ${event.recordId}`);
    };

    const handleReconnected = () => {
      message.success("Подключение восстановлено");
      // Можно перезагрузить записи для синхронизации
      getRecords();
    };

    const handleError = (error) => {
      console.error("Ошибка SignalR:", error);
      setSignalRConnected(false);
    };

    // Инициализируем SignalR
    recordSignalRService.initialize(sessionId, date, {
      onRecordAdded: handleRecordAdded,
      onRecordUpdated: handleRecordUpdated,
      onRecordsUpdated: handleRecordsUpdated,
      onRecordDeleted: handleRecordDeleted,
      onReconnected: handleReconnected,
      onError: handleError
    })
      .then(() => {
        setSignalRConnected(true);
        // console.log("SignalR успешно инициализирован");
      })
      .catch(error => {
        console.error("Не удалось инициализировать SignalR:", error);
        setSignalRConnected(false);
        // Не показываем ошибку пользователю, просто работаем без real-time обновлений
      });

    // Cleanup при размонтировании компонента
    return () => {
      recordSignalRService.stop()
        .catch(error => console.error("Ошибка остановки SignalR:", error));
    };
  }, []); // Запускаем только один раз при монтировании

  // Обработка изменения даты для переподписки
  useEffect(() => {
    // Пропускаем первый рендер
    if (previousDateRef.current === null) {
      previousDateRef.current = date;
      return;
    }

    // Проверяем, изменилась ли дата
    const dateChanged = !previousDateRef.current.isSame(date, 'day');
    if (dateChanged && signalRConnected) {
      // Переподписываемся на новую дату
      recordSignalRService.changeDate(date)
        .then((result) => {
          console.log("Переподписка на новую дату:", result);
        })
        .catch(error => {
          console.error("Ошибка переподписки на новую дату:", error);
          // Если не удалось переподписаться, можно попробовать переподключиться
        });
    }

    previousDateRef.current = date;
  }, [date, signalRConnected]);

  // Ширина столбца времени
  const timeColWidth = 60;
  // Высота шапки
  const headerRowHeight = 50;

  // Функция для сохранения режима отображения в localStorage
  const saveVid = (value) => {
    localStorage.setItem('records-vid', value.toString());
  };

  const savePeriod = (value) => {
    localStorage.setItem("records-period", value);
    setPeriod(value);
  };

  const onOpenDay = (day) => {
    setDate(day);
    savePeriod("day");
  };

  const shiftPeriod = (direction) => {
    const unit = period === "day" ? "day" : period;
    setDate(current => current.add(direction, unit));
  };

  // Функция для сохранения ширины колонки в localStorage
  const saveUserColWidth = (width) => {
    localStorage.setItem('records-userColWidth', width.toString());
  };

  // Функция для сохранения высоты строки в localStorage
  const saveHourRowHeight = (height) => {
    localStorage.setItem('records-hourRowHeight', height.toString());
  };

  // Обработчики ресайза колонки
  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsResizing(true);
    document.body.classList.add('resizing');
    const startX = e.clientX;
    const startWidth = userColWidth;

    const handleMouseMove = (e) => {
      const deltaX = e.clientX - startX;
      const newWidth = Math.max(minColWidth, Math.min(400, startWidth + deltaX));
      setUserColWidth(newWidth);
      saveUserColWidth(newWidth);
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.body.classList.remove('resizing');
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // Обработчики ресайза высоты строки
  const handleHeightMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsResizingHeight(true);
    document.body.classList.add('resizing-height');
    const startY = e.clientY;
    const startHeight = hourRowHeight;

    const handleMouseMove = (e) => {
      const deltaY = e.clientY - startY;
      const newHeight = Math.max(30, Math.min(200, startHeight + deltaY));
      setHourRowHeight(newHeight);
      saveHourRowHeight(newHeight);
    };

    const handleMouseUp = () => {
      setIsResizingHeight(false);
      document.body.classList.remove('resizing-height');
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const isToday = dayjs(date).isSame(dayjs(), 'day');

  const todayUsers = vid === 0 ? [{id: null, name: ""}, ...users.filter(i => calendars.includes(i.calendarId))] 
    : [{id: null, name: ""}, ...rooms.filter(i => i.active)];

  const divLines = Array.from({ length: company?.hourFinish - company?.hourStart ?? 0}, (_, hour) =>
    <RecordsLine 
      key={company.hourStart + hour} 
      hour={company.hourStart + hour} 
      users={todayUsers} 
      height={hourRowHeight} 
      timeWidth={timeColWidth} 
      userWidth={userColWidth} 
      isToday={isToday}
      grafs={grafs}
      onSelectTime={value => setSelectedTime({docDate: date, ...value, isGroup: false, })}
      vid={vid}
      onResizeHeight={handleHeightMouseDown}
    />)  

  const onCloseEdit = (refresh) => {
    setSelectedItem(null);
    setSelectedTime(null);
    setMode(null);
    refresh && getRecords();
  }

  const onVisit = item => setVisitItem(item);
  const onVisitClose = refresh => {
    setVisitItem();
    refresh && getRecords();
  }

  const filteredItems = records.filter(i => {
    if (!showDeleted && i.deleted) return false;
    if (selectedClient && !i.cnts.find(j => j.objectVid === 1 && j.objectId === selectedClient)) return false;
    return true;
  });

  const periodRange = getPeriodRange(date, period);
  const isCurrentPeriod = period === "week"
    ? date.isSame(dayjs(), "isoWeek")
    : period === "month"
      ? date.isSame(dayjs(), "month")
      : date.isSame(dayjs(), "day");

  const datePickerFormat = (value) => {
    if (!value) return "";
    if (period === "month") return value.format("MMMM YYYY");
    if (period === "week") {
      const begin = value.startOf("isoWeek");
      const end = value.endOf("isoWeek");
      if (begin.month() === end.month()) return `${begin.format("D")}–${end.format("D MMMM YYYY")}`;
      if (begin.year() === end.year()) return `${begin.format("D MMM")} – ${end.format("D MMM YYYY")}`;
      return `${begin.format("D MMM YYYY")} – ${end.format("D MMM YYYY")}`;
    }
    return value.format("DD.MM.YYYY");
  };

  const onChangeSelect = id =>  {
    const has = selected.find(i => i === id);
    const newSelected = [...selected.filter(i => i !== id)];
    if (!has) newSelected.push(id);
    setSelected(newSelected);
  }

  const onCopyClose = refresh => {
    setShowCopy(false);
    refresh && getRecords();
    refresh && setSelected([]);
  }

  const onRezClose = id => {
    setRezShow(false);
    id && setSelectedItem(id);
  }

  const onSmartClose = refresh => {
    setMode(null);
    setSmartRecord(false);
    refresh && getRecords();
  }

  // Обработчики drag and drop для контейнера записей
  const handleContainerDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setIsDragOver(true);
  };

  const handleContainerDragLeave = (e) => {
    // Проверяем, что мы действительно покинули контейнер, а не перешли к дочернему элементу
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false);
    }
  };

  const handleContainerDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    try {
      const dragData = JSON.parse(e.dataTransfer.getData('text/plain'));
      
      // Определяем новую позицию на основе координат drop относительно контейнера
      const rect = e.currentTarget.getBoundingClientRect();
      const dropX = e.clientX - rect.left;
      const dropY = e.clientY - rect.top;
      
      // Вычисляем новый столбец (сотрудник/зал)
      const newColumnIndex = Math.floor((dropX - timeColWidth) / userColWidth);
      const newUser = todayUsers[newColumnIndex];
      
      // Вычисляем новое время с шагом 15 минут
      const relativeY = dropY - headerRowHeight;
      const minutesFromStart = (relativeY / hourRowHeight) * 60;
      const roundedMinutes = Math.round(minutesFromStart / 15) * 15;
      const newStart = dayjs().startOf('day').add((company?.hourStart ?? 0) * 60 + roundedMinutes, 'minute');
      
      // Вычисляем новое время окончания (сохраняем длительность)
      const duration = dayjs(dragData.finish, 'HH:mm').diff(dayjs(dragData.start, 'HH:mm'), 'minute');
      const newFinish = newStart.add(duration, 'minute');
      
      // Обновляем запись
      updateRecordOnServer(dragData.id, {
        newUserId: vid === 0 ? newUser?.id : dragData.userId,
        newRoomId: vid === 1 ? newUser?.id : dragData.roomId,
        newStart: newStart,
        newFinish: newFinish
      });
    } catch (error) {
      console.error('Error handling container drop:', error);
    }
  };

  // Функция для обновления записи на сервере
  const updateRecordOnServer = async (recordId, newData) => {
    try {
      // Находим запись в локальном состоянии
      const recordIndex = records.findIndex(record => record.id === recordId);
      if (recordIndex === -1) {
        message.error('Запись не найдена');
        return;
      }

      const originalRecord = records[recordIndex];
      // Создаем обновленную запись
      const updatedRecord = {
        ...originalRecord,
        userId: newData.newUserId,
        roomId: newData.newRoomId,
        start: newData.newStart,
        finish: newData.newFinish
      };

      // Обновляем локальное состояние
      setRecords(prevRecords => {
        const newRecords = [...prevRecords];
        newRecords[recordIndex] = updatedRecord;
        return newRecords;
      });

      // Подготавливаем полную обновленную запись для отправки на сервер
      const updateData = {
        record: {
          ...updatedRecord,
          start: newData.newStart.format('HH:mm:ss'),
          finish: newData.newFinish.format('HH:mm:ss'),
          docDate: strDate2Server(updatedRecord.docDate),
          maxClients: updatedRecord.maxClients || 0
        },
        propagationScope: null
      };

      // Отправляем запрос на сервер
      await serverFetch('record', {
        method: 'PUT',
        bodyData: updateData
      });

      message.success('Запись успешно перемещена');
    } catch (error) {
      // В случае ошибки откатываем изменения
      getRecords();
      message.error(error.userMessage || 'Ошибка при перемещении записи');
    }
  };

  useEffect(() => {
    if (mobileTypeFilter !== 0 && mobileTypeFilter !== 1 && mobileTypeFilter !== 2) return;

    if (mobileTypeFilter === 1 || mobileTypeFilter === 0) {
      const keyField = mobileTypeFilter === 1 ? 'roomId' : 'userId';
      const labelField = mobileTypeFilter === 1 ? 'roomName' : 'userName';
      const uniqueItems = Array.from(
        new Map(
          records.filter(item => item[keyField] != null).map(item => [item[keyField], { value: item[keyField], label: item[labelField] }])).values()
      );
      setUniqueValues(uniqueItems);
    }

    if (mobileTypeFilter === 2) {
    const clientMap = new Map();
      records.forEach(record => {
        if (!record.cnts) return;
        record.cnts.forEach(cnt => {
          // Используем objectId как уникальный ключ
          if (!clientMap.has(cnt.objectId) && cnt.objectVid == 1) {
            clientMap.set(cnt.objectId, {
              value: cnt.objectId,
              label: cnt.objectName || 'Без имени'
            });
          }
        });
      });
      const uniqueClients = Array.from(clientMap.values());
      setUniqueValues(uniqueClients);
    }
    localStorage.setItem('mobileTypeFilter', mobileTypeFilter);
  }, [mobileTypeFilter, records])

  const filteredSortedItems = useMemo(() => {
    
    let filtered = records;

    if (!showDeleted) {
      filtered = filtered.filter(record => !record.deleted);
    }
    // Фильтруем только если фильтр указан
    if (currentFilter !== null && currentFilter !== undefined) {
      if (mobileTypeFilter === 1) {
        // Фильтр по залу (roomId)
        filtered = records.filter(record => record.roomId === currentFilter);
      } else if (mobileTypeFilter === 0) {
        // Фильтр по сотруднику (userId)
        filtered = records.filter(record => record.userId === currentFilter);
      } else if (mobileTypeFilter === 2) {
        // Фильтр по клиенту
        filtered = records.filter(record =>
          record.cnts?.some(cnt =>
            cnt.objectId === currentFilter
          )
        );
      }
    }
    return filtered.sort((a, b) => new Date(a.start) - new Date(b.start));
  }, [records, currentFilter, showDeleted]);

  const divVisit = () => {
    if (!visitItem) return null;
    const clients = visitItem.cnts.filter(i3 => i3.objectVid === 1);
    if (clients.length !== 1 || clients[0].objectVid !== 1)
      return <RecordVisit id={visitItem.id} onClose={onVisitClose} onRefresh={getRecords} />
    const clientId = clients[0].objectId;
    // В записи один клиент только один клиент
    // Найти записи в который только этот клиент и только один клиент
    const items = records.filter(i => i.cnts.filter(i2 => i2.objectVid === 1).length === 1 && i.cnts.filter(i2 => i2.objectVid === 1)[0].objectId === clientId);
    // // Надо в записях по услугам установить флаг used=true для услуг в записях которых есть этот клиент с used === true
    // items.forEach(item => item.used = records.find(r => r.id === item.recordId)?.cnts.find(c => c.objectVid === 1 && c.objectId === clientId)?.used ?? false);
    // console.log(clientId, records, items)
    if (items.length > 1) return <RecordSmartVisit item={visitItem} onClose={onVisitClose} onRefresh={getRecords} items={items}/>
    // Иначе открываем RecordVisit
    return <RecordVisit id={visitItem.id} onClose={onVisitClose} onRefresh={getRecords} />
  }

  if (isMobile) {
    return (
    <>
      <div style={{ position: "relative", height: window.innerHeight - 45.8 }}>
      <div className="col-one-title-upper-menu">
        <div className="filters-layout-wrapper">
        <DatePicker value={date} onChange={e => setDate(e)} format="DD.MM.YYYY" allowClear={false} className="rounded-search-field"/>
        <button className="rounded-filter-button" onClick={() => setIsExpanded(!isExpanded)}>
          <img src="/images/filter.svg" className="mobile-top-img" alt="filter" style={{ width: "20px", height: "20px" }} />
        </button>
      </div>

      {/* Раскрывающаяся часть фильтров */}
      <div className={`filter-expandable-content ${isExpanded ? 'expanded' : ''}`}>
        <div className="filter-inside-wrapper">
          
          {/* Тип фильтра */}
          <div className="filter-field-item">
            <Select 
              placeholder="Выбор типа фильтра" 
              value={mobileTypeFilter} 
              className="rounded-search-field custom-select-field" 
              options={filtersTypes} 
              onChange={(value) => {
                setMobileTypeFilter(value);
                setCurrentFilter(null);
              }}
            />
          </div>

          {/* Динамическое значение */}
          <div className="filter-field-item">
            <Select 
              placeholder={mobileTypeFilter === 1 ? "Фильтр по залу" : (mobileTypeFilter === 2 ? "Фильтр по клиенту" : "Фильтр по сотруднику")} 
              className="rounded-search-field custom-select-field"
              allowClear 
              onChange={e => setCurrentFilter(e)} 
              options={uniqueValues} 
              value={currentFilter}
            />
          </div>

          {/* Чекбокс */}
          <div className="filter-checkbox-item">
            <Checkbox checked={showDeleted} onChange={e => setShowDeleted(e.target.checked)}>
              Отмененные
            </Checkbox>
          </div>

        </div>
      </div>
    </div>
  
      {rezShow ? <RecordsItem data={rezItems} onClick={setSelectedItem} />: <RecordsItem data={filteredSortedItems} onClick={setSelectedItem} />}
      </div>
      <FloatButton.Group trigger="click" icon={<PlusOutlined /> }>
        <FloatButton style={{ insetBlockEnd: 196 }}  icon={<ScheduleOutlined style={{color:'#2f6f00'}}/>} onClick={() => setRezShow(!rezShow)} />
        <FloatButton style={{ insetBlockEnd: 108 }} onClick={() => {setMode(1)}} icon={<PlusSquareOutlined style={{color:'#2f6f00'}}/>} />
        <FloatButton onClick={() => setMode(2)} icon={<AppstoreAddOutlined style={{color:'#2f6f00'}}/>}/>
      </FloatButton.Group>
      
      {/* Обработка клика по карточке - показываем информацию по записи */}
      {selectedItem && <Record id={selectedItem} onClose={onCloseEdit} onRefresh={getRecords} users={users} records={records} recordPassVidDefault={company?.recordPassVid} />}
      {mode === 1 && <Record id={selectedItem} onClose={onCloseEdit} onRefresh={getRecords} users={users} records={records} recordPassVidDefault={company?.recordPassVid} />}
      {mode === 2 && <RecordsSmart onClose={onSmartClose} recordPassVidDefault={company?.recordPassVid} />}
    </>
    )
  }
 else
  return<div className="col-one-main records-page">
    <div className="col-one-title records-toolbar">
      <Tooltip title={signalRConnected ? "Real-time обновления активны" : "Real-time обновления не активны"}>
        <Badge status={signalRConnected ? "success" : "error"} style={{marginRight: 8}}/>{/* text={signalRConnected ? "On" : "Off"}  */}
      </Tooltip>
      <Select
        className="records-period"
        options={PERIOD_OPTIONS}
        value={period}
        onChange={savePeriod}
        style={{ width: 110 }}
      />
      <div className="records-date-nav">
        <Button className="icon-btn" icon={<LeftOutlined />} onClick={() => shiftPeriod(-1)} />
        <DatePicker
          value={date}
          onChange={e => e && setDate(e)}
          picker={period === "month" ? "month" : period === "week" ? "week" : "date"}
          format={datePickerFormat}
          allowClear={false}
          className="records-date-picker"
          style={{
            width: period === "day" ? 112 : period === "month" ? 140 : 178,
          }}
        />
        <Button className="icon-btn" icon={<RightOutlined />} onClick={() => shiftPeriod(1)} />
      </div>      {!isCurrentPeriod ? <Button onClick={() => setDate(dayjs())}>Сегодня</Button> : null}
      {period === "day" ? (
        <Select
          className="records-vid-select"
          options={vidOptions}
          value={vid}
          popupMatchSelectWidth={false}
          onChange={newVid => {
            setVid(newVid);
            saveVid(newVid);
          }}
        />
      ) : null}
      <Select placeholder="Клиент" style={{width: 200}} options={clients} onChange={e => setSelectedClient(e)} value={selectedClient} allowClear/>
      <div className="records-icon-btns">
        <Tooltip title={showDeleted ? "Скрыть отмененные" : "Показать отмененные"}>
          <Button
            className={`icon-btn${showDeleted ? " icon-btn-on" : ""}`}
            type={showDeleted ? "primary" : "default"}
            icon={<CloseCircleOutlined />}
            onClick={() => setShowDeleted(v => !v)}
          />
        </Tooltip>
        <Tooltip title={rezShow ? "Скрыть резерв" : "Показать заявки в резерве"}>
          <Badge count={rezItems.length} size="small" offset={[-4, 4]} className="records-rez-badge">
            <Button
              className={`icon-btn${rezShow ? " icon-btn-on" : ""}`}
              type={rezShow ? "primary" : "default"}
              icon={<ScheduleOutlined />}
              disabled={!rezItems.length && !rezShow}
              onClick={() => setRezShow(v => !v)}
            />
          </Badge>
        </Tooltip>
        <RefreshButton onClick={getRecords} />
        <CopyButton onClick={() => setShowCopy(true)} disabled={selected.length === 0} />
        <Tooltip title="Сбросить выбранные записи"><Button className="icon-btn" onClick={() => setSelected([])} disabled={selected.length === 0}>X</Button></Tooltip>
        <SmartButton onClick={() => setSmartRecord(true)} id="tour-item-records-smart-record-button" />
        <ButtonReport vid={2} begPer={periodRange.begin} endPer={periodRange.end} id={0}/>
        <HelpButton article="predvaritelnaya-zapis" />
      </div>
    </div>
    <div className={`records ${isDragOver ? "drag-over" : ""} ${period !== "day" ? "records-fill" : ""}`} onDragOver={period === "day" ? handleContainerDragOver : undefined} onDragLeave={period === "day" ? handleContainerDragLeave : undefined} onDrop={period === "day" ? handleContainerDrop : undefined}>
      {period === "week" ? (
        <RecordsWeek
          date={date}
          records={filteredItems}
          company={company}
          onOpenRecord={setSelectedItem}
          onOpenDay={onOpenDay}
          onSelectTime={setSelectedTime}
        />
      ) : period === "month" ? (
        <RecordsMonth
          date={date}
          records={filteredItems}
          onOpenRecord={setSelectedItem}
          onOpenDay={onOpenDay}
        />
      ) : (
        <>
      <RecordsHeader 
        users={todayUsers} 
        height={headerRowHeight} 
        timeWidth={timeColWidth} 
        userWidth={userColWidth} 
        records={filteredItems} 
        vid={vid} 
        onResize={handleMouseDown}
        calendars={calendarsList}
      />
      <div className="records-lines">{divLines}</div>
      {filteredItems.filter(item => item.start && item.finish).map(item => {
        const idx = vid === 0 
          ? todayUsers.indexOf(todayUsers.find(i => (i.id === null && item.userId === null) || i.id === item.userId))
          : todayUsers.indexOf(todayUsers.find(i => (i.id === null && item.roomId === null) || i.id === item.roomId));
        const left = timeColWidth + (idx + 0.05)*userColWidth;
        const top = headerRowHeight + (item.start.diff(item.start.startOf('day'), 'minute') - (company?.hourStart ?? 0)*60)/60*hourRowHeight;
        const height = item.finish.diff(item.start, "minute")/60*hourRowHeight;
        return <RecordsItem 
          item={item} 
          left={left} 
          top={top} 
          width={userColWidth*0.9} 
          height={height} 
          onClick={setSelectedItem} 
          key={item.id}
          onVisit={onVisit}
          onChangeSelect={onChangeSelect}
          selected={selected}
          onUpdate={getRecords}
          timeColWidth={timeColWidth}
          userColWidth={userColWidth}
          headerRowHeight={headerRowHeight}
          hourRowHeight={hourRowHeight}
          company={company}
          todayUsers={todayUsers}
          vid={vid}
          updateRecordOnServer={updateRecordOnServer}
        />
    })}
        </>
      )}
    </div>
    {selectedTime && <Record defaultItem={selectedTime} onClose={onCloseEdit} onRefresh={getRecords} users={users} records={records} recordPassVidDefault={company?.recordPassVid} />}
    {selectedItem && <Record id={selectedItem} onClose={onCloseEdit} onRefresh={getRecords} users={users} records={records} recordPassVidDefault={company?.recordPassVid} />}
    {showCopy && <RecordsCopy items={selected} onClose={onCopyClose} />}
    {rezShow && <RecordsRezItems items={rezItems} onClose={onRezClose} />}
    {smartRecord && <RecordsSmart onClose={onSmartClose} recordPassVidDefault={company?.recordPassVid} />}
    {divVisit()}
  </div>
}

export default Records;